import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';

export default {
    name: 'DeliveryPage',
    components: {
        NavBar,
    },
    data() {
        return {
            type: 'available',
            page: 1,
            more: true,
            loading: false,
            entities: [],
            dateFormat: functions.dateFormat
        }
    },
    created() {
        this.getDataList();
    },
    methods: {
        getDataList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('deliver/' + this.type, {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.more = result.data.more;
                    this.entities = this.entities.concat(result.data.entities);
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        changeType(value) {
            this.more = true;
            this.page = 1;
            this.entities = [];
            this.type = value;
            this.getDataList();
        },
        scroll(event) {
            if (event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight <= 100) {
                this.getDataList();
            }
        }
    }
}